<template>
  <svg class="cg-chart" :viewBox="`0 0 ${W} ${H}`">
    <g v-for="(t, i) in ticks" :key="`g-${i}`">
      <line class="cg-grid" :x1="ML" :y1="y(t)" :x2="W - MR" :y2="y(t)" />
      <text class="cg-axv" :x="ML - 6" :y="y(t) + 3" text-anchor="end">{{ t }}</text>
    </g>
    <g v-for="(cat, ci) in grupo.categorias" :key="`c-${ci}`">
      <text class="cg-ax" :x="centro(ci)" :y="H - 9" text-anchor="middle">{{ cat }}</text>
      <rect
        v-for="(barra, si) in barras(ci)"
        :key="si"
        :x="barra.x"
        :y="barra.y"
        :width="anchoBarra"
        :height="barra.h"
        :fill="barra.hex"
        rx="3"
        class="cg-hit"
        @mousemove="$emit('tip', $event, barra.tip)"
        @mouseleave="$emit('untip')"
      />
    </g>
  </svg>
</template>

<script>
import { nf } from "./cobertura";

export default {
  name: "GraficoBarras",
  props: {
    grupo: { type: Object, required: true },
    unidad: { type: String, default: "" },
    denso: { type: Boolean, default: false },
  },
  data() {
    return { H: 250, ML: 34, MR: 12, MT: 14, MB: 30 };
  },
  computed: {
    W() {
      return this.denso ? 900 : 520;
    },
    maxValor() {
      let max = 0;
      this.grupo.series.forEach((s) => s.valores.forEach((v) => { if (v > max) max = v; }));
      return Math.max(max, 1);
    },
    ticks() {
      const n = this.maxValor <= 4 ? this.maxValor : 4;
      const out = [];
      for (let i = 0; i <= n; i++) out.push(Math.round((this.maxValor * i) / n));
      return out;
    },
    banda() {
      return (this.W - this.ML - this.MR) / this.grupo.categorias.length;
    },
    anchoBarra() {
      const n = this.grupo.series.length;
      const grupoW = Math.min(this.banda * 0.72, this.denso ? 22 : 80);
      const sep = n > 1 ? 2 : 0;
      return Math.max(Math.min((grupoW - (n - 1) * sep) / n, 24), 2);
    },
  },
  methods: {
    y(v) {
      const alto = this.H - this.MT - this.MB;
      return this.MT + (1 - v / this.maxValor) * alto;
    },
    centro(ci) {
      return this.ML + this.banda * ci + this.banda / 2;
    },
    barras(ci) {
      const n = this.grupo.series.length;
      const sep = n > 1 ? 2 : 0;
      const total = this.anchoBarra * n + sep * (n - 1);
      const base = this.MT + (this.H - this.MT - this.MB);
      return this.grupo.series
        .map((s, si) => {
          const v = s.valores[ci];
          if (!v) return null;
          return {
            x: this.centro(ci) - total / 2 + si * (this.anchoBarra + sep),
            y: this.y(v),
            h: base - this.y(v),
            hex: s.hex,
            tip: `${this.grupo.categorias[ci]}<br>${s.alias}: <b>${nf(v)}</b> ${this.unidad}`,
          };
        })
        .filter(Boolean);
    },
  },
};
</script>

<style scoped>
.cg-chart {
  width: 100%;
  height: auto;
  display: block;
  overflow: visible;
}
.cg-grid {
  stroke: var(--cg-line);
  stroke-width: 1;
}
.cg-ax,
.cg-axv {
  font-family: var(--cg-font-mono);
  font-size: 9px;
  fill: var(--cg-muted);
}
.cg-hit {
  cursor: pointer;
}
</style>
